/*jshint esversion:8*/
const { isApiKeyVisibleToUser, isApiKeyDisabled, isApiKeyActive } = require("./utils/apiKeys.ts");
var tokens = {};
var getKeyPromises = {};
function fetchApiKey(local) {
    return function (workspaceId, { projectGroupId } = {}) {
        const cacheKey = workspaceId + (projectGroupId ? `-${projectGroupId}` : "");
        if (tokens[cacheKey]) {
            return Promise.resolve(tokens[cacheKey]);
        }

        if (getKeyPromises[cacheKey]) {
            return getKeyPromises[cacheKey];
        }

        if (!local.restricted.HAS_COOKIE || !workspaceId) {
            return new Promise(function (resolve, reject) {
                setTimeout(function () {
                    fetchApiKey(local)(workspaceId || window.user?.uid)
                        .then((res) => resolve(res))
                        .catch((err) => reject(err));
                }, 500);
            });
        }

        var getKeyPromise = new Promise(function (resolve, reject) {
            db.collection("api_keys")
                .where("workspace", "==", workspaceId)
                .get()
                .then((snapshot) => {
                    const apiKeys = snapshot.docs
                        // Filter out device keys and soft-deleted keys (revoked)
                        .filter((d) => !d.data().deviceId && isApiKeyVisibleToUser(d.data()))
                        .sort((a, b) => (a.data().created_on || 0) - (b.data().created_on || 0));

                    const { activeKeys, disabledKeys } = apiKeys.reduce(
                        (acc, d) => {
                            if (isApiKeyDisabled(d.data())) {
                                // backwards compatibility with legacy revoked: true
                                acc.disabledKeys.push(d);
                            } else if (isApiKeyActive(d.data())) {
                                acc.activeKeys.push(d);
                            }
                            return acc;
                        },
                        { activeKeys: [], disabledKeys: [] }
                    );

                    // don't create new keys if there is a search match
                    // for an active or disabled key. prioritize active keys over disabled keys,
                    // so order here matters (b/c use find() below, will grab first match)
                    const priorityKeys = [...activeKeys, ...disabledKeys];

                    let keysToSearch = priorityKeys.length > 0 ? priorityKeys : apiKeys;

                    let keyDoc;
                    if (projectGroupId) {
                        keyDoc = keysToSearch.find((d) =>
                            d.data().projectGroupIds?.includes(projectGroupId)
                        );
                    } else {
                        // prefer explicit default
                        // else oldest key
                        keyDoc =
                            keysToSearch.find((d) => d.data().default) ??
                            keysToSearch.find((d) => !d.data().projectGroupIds);
                    }

                    if (!keyDoc) {
                        $.post(
                            "/query/createApiKey",
                            {
                                workspaceId: workspaceId,
                                projectGroupIds: projectGroupId ? [projectGroupId] : null
                            },
                            function (response) {
                                tokens[cacheKey] = response.key;
                                resolve(tokens[cacheKey]);
                            },
                            "JSON"
                        );
                    } else {
                        const key = keyDoc.data();
                        key.id = keyDoc.id;

                        //rest of the front end curently expects this to be set here
                        tokens[cacheKey] = key.id;
                        resolve(tokens[cacheKey]);
                    }
                })
                .catch((err) => {
                    // Labelers can't retrieve an API key for the workspace
                    // but they also don't need to use it for anything
                    // so we set it to a dummy value
                    tokens[cacheKey] = "unauthorized";
                    resolve(tokens[cacheKey]);
                });
        });

        getKeyPromises[cacheKey] = getKeyPromise;
        return getKeyPromise;
    };
}

module.exports = fetchApiKey;
